import * as React from 'react';
import * as PropTypes from 'prop-types';
import IconWrapper from './IconWrapper';

const IconWidgetPrescription = props =>
  React.createElement(
    IconWrapper,
    props,
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      className="block w-full h-full fill-current"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 13.5C4 10.1863 6.68629 7.5 10 7.5H30C33.3137 7.5 36 10.1863 36 13.5V26.8333C36 30.147 33.3137 32.8333 30 32.8333H10C6.68629 32.8333 4 30.147 4 26.8333V13.5ZM10 9.5C7.79086 9.5 6 11.2909 6 13.5V26.8333C6 29.0425 7.79086 30.8333 10 30.8333H30C32.2091 30.8333 34 29.0425 34 26.8333V13.5C34 11.2909 32.2091 9.5 30 9.5H10Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 15.501C9 14.9487 9.44772 14.501 10 14.501H19C19.5523 14.501 20 14.9487 20 15.501C20 16.0533 19.5523 16.501 19 16.501H10C9.44772 16.501 9 16.0533 9 15.501Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 16.501C24 15.9487 24.4477 15.501 25 15.501H31C31.5523 15.501 32 15.9487 32 16.501C32 17.0533 31.5523 17.501 31 17.501H25C24.4477 17.501 24 17.0533 24 16.501Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28 20.501C27.4477 20.501 27 20.0533 27 19.501L27 13.501C27 12.9487 27.4477 12.501 28 12.501C28.5523 12.501 29 12.9487 29 13.501L29 19.501C29 20.0533 28.5523 20.501 28 20.501Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 19.501C9 18.9487 9.44772 18.501 10 18.501H19C19.5523 18.501 20 18.9487 20 19.501C20 20.0533 19.5523 20.501 19 20.501H10C9.44772 20.501 9 20.0533 9 19.501Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 23.501C9 22.9487 9.44772 22.501 10 22.501H19C19.5523 22.501 20 22.9487 20 23.501C20 24.0533 19.5523 24.501 19 24.501H10C9.44772 24.501 9 24.0533 9 23.501Z"
      />
    </svg>,
  );

IconWidgetPrescription.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
};
export default IconWidgetPrescription;
